import React, { memo } from 'react';
import { Panel } from '@app/components';
import { IOrder } from '@app/common';
import { OrderCard } from './OrderCard';
import styled from '@2pulse/responsive';
import { normalize } from '@app/helpers';

type ServiceOrdersProps = {
  orders: IOrder[];
  isFetching: boolean;
};

export const ServiceOrders = memo(({ orders, isFetching }: ServiceOrdersProps) => {
  return (
    <Panel.Content>

      <Panel.FormContainer>

        <OrderCards>
          {orders.map((order) => (
            <OrderCard key={order._id} order={order} />
          ))}
        </OrderCards>
      </Panel.FormContainer>

    </Panel.Content>
  );
});

const OrderCards = styled.View({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  rowGap: normalize(13),
});
